import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface TaxEditorViewProps  {
    taxRequest: DropdownRequest<TaxSummary>;
    value: number | null;
    mode: ControlMode;
    onChanged: (number: any) => void;
    label?: string;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

@observer
export class TaxEditorView extends React.Component<TaxEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Tax';
        }
        return (
            <DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => { this.props.onChanged(item) }}
				request={this.props.taxRequest}
				keyField='id'
				textField='displayName'
				afterLoad={this.props.afterLoad}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/parts/tax-editor.view.tsx